export { default as useSelectedProductsSidebarAttachModalButton } from './useSelectedProductsSidebarAttachModalButton';
